import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

import "bootstrap/scss/bootstrap.scss";
import "react-toastify/scss/main.scss";
import "./assets/scss/fontawesome.scss";
import "./assets/scss/brands.scss";
import "./assets/scss/regular.scss";
import "./assets/scss/solid.scss";
import "./assets/main.scss";
import "./assets/fix-container.scss";
import "yet-another-react-lightbox/styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
